export default __webpack_public_path__ + "static/kaave_logo-d5aa7444678a6ed45aa55fb9aee38a62.png";